// src/data/examExplanations.js
// Rozszerzone omówienia pytań egzaminacyjnych - po jednym wpisie na slug pytania.
//
// Każdy wpis zasila podstronę /pytania/<slug>:
//   why     - dlaczego to zagadnienie pojawia się na egzaminie i skąd wynika,
//   detail  - rozwinięcie merytoryczne (jeden lub dwa akapity),
//   mistake - najczęstszy błąd przy tym pytaniu.
//
// Treść ma charakter edukacyjny i nie zastępuje aktualnego brzmienia ustawy
// z 21 maja 1999 r. o broni i amunicji ani regulaminów PZSS/ISSF.

export const EXAM_EXPLANATIONS = {
  // ---------------------------------------------------------------- część 1
  'pociski-zaliczaja-sie-do-amunicji': {
    why: 'To jedno z pierwszych pytań definicyjnych, bo od pojęcia amunicji zależy cała reszta przepisów: co wolno kupić, co trzeba zarejestrować i za co grozi odpowiedzialność karna.',
    detail: [
      'Ustawa traktuje jako amunicję kompletny nabój, a więc zestaw elementów pozwalających oddać strzał: pocisk, łuskę z ładunkiem miotającym i spłonkę. Kluczowe jest słowo „komplet" - dopiero połączenie tych części tworzy amunicję w rozumieniu przepisów.',
      'Przeznaczenie naboju nie zmienia jego kwalifikacji. Nabój sportowy, bojowy i szkoleniowy są tak samo amunicją, jeśli nadają się do wystrzelenia z broni palnej. Sam pocisk, oddzielony od łuski i spłonki, co do zasady amunicją nie jest - ale uwaga, niektóre pociski są osobno uznane za istotne części amunicji.',
    ],
    mistake: 'Uznawanie luźnych pocisków za amunicję. Sam pocisk to jeszcze nie nabój - chyba że zawiera materiały wybuchowe lub chemiczne, wtedy jest istotną częścią amunicji.',
  },
  'co-to-jest-amunicja-szczegolnie-niebezpieczna': {
    why: 'Kategoria „szczególnie niebezpieczna" wraca w pytaniach o zakazy i o odpowiedzialność karną, dlatego warto znać ją z nazwy, a nie tylko intuicyjnie.',
    detail: [
      'Chodzi o amunicję, która ze względu na konstrukcję zwiększa zagrożenie dla życia i zdrowia ponad zwykłe ryzyko związane ze strzelaniem. Ustawa wylicza ją zamkniętym katalogiem, więc na egzaminie liczy się rozpoznanie konkretnych typów, a nie ogólna ocena „czy coś jest groźne".',
      'Do katalogu należą pociski podkalibrowe (także z tworzyw sztucznych), amunicja z materiałami wybuchowymi, zapalającymi lub smugowymi oraz amunicja wytworzona niefabrycznie albo przerobiona tak, że zmieniono jej pierwotne właściwości.',
    ],
    mistake: 'Mylenie amunicji szczególnie niebezpiecznej z amunicją elaborowaną samodzielnie. Samodzielne elaborowanie na własny użytek jest dopuszczalne dla wybranych pozwoleń - przerabianie zmieniające właściwości już nie.',
  },
  'na-jakiej-podstawie-mozna-nabyc-amunicje': {
    why: 'Pytanie sprawdza, czy kandydat rozumie, że pozwolenie na broń nie jest „biletem na wszystko" - zakres zakupu amunicji jest ściśle powiązany z posiadaną legitymacją.',
    detail: [
      'Osoba fizyczna kupuje amunicję na podstawie legitymacji posiadacza broni, ale wyłącznie w kalibrach i rodzajach odpowiadających broni, na którą ma pozwolenie. Nie można więc kupić amunicji „na zapas" do broni, której się nie posiada.',
      'Drugą podstawą jest pisemne zamówienie uprawnionego podmiotu prowadzącego obrót bronią lub amunicją. W obu przypadkach obowiązek weryfikacji uprawnień spoczywa na sprzedawcy - to on odpowiada za wydanie amunicji osobie nieuprawnionej.',
    ],
    mistake: 'Założenie, że posiadacz dowolnego pozwolenia może kupić dowolną amunicję. Decyduje zgodność kalibru i rodzaju broni z wpisem w legitymacji.',
  },
  'mozna-przenosic-z-bronia-palna-do-celow-sportowych': {
    why: 'Zasady przenoszenia broni są egzekwowane w praktyce - to jedno z tych zagadnień, których nieznajomość kończy się nie tylko utratą punktu na egzaminie, ale i realnym postępowaniem.',
    detail: [
      'Broń przenoszona do celów sportowych musi być rozładowana: bez naboju w komorze nabojowej i z magazynkami pozbawionymi amunicji. Stan „gotowa do strzału" jest dopuszczalny wyłącznie na stanowisku strzeleckim, na komendę prowadzącego.',
      'Dodatkowo broń powinna znajdować się w pokrowcu, futerale lub innym zamkniętym opakowaniu, które uniemożliwia przypadkowe użycie i nie sygnalizuje otoczeniu, co jest przenoszone.',
    ],
    mistake: 'Przekonanie, że wystarczy wyjąć magazynek. Komora nabojowa musi być pusta, a magazynki - nienaładowane.',
  },
  'nalezy-zarejestrowac-zakupiona-bron': {
    why: 'Terminy to najczęściej sprawdzana grupa pytań, bo odpowiedź jest jednoznaczna i łatwo wykazać jej nieznajomość.',
    detail: [
      'Broń nabytą na podstawie zaświadczenia uprawniającego do zakupu rejestruje się w terminie 5 dni od dnia nabycia. Rejestracji dokonuje właściwa jednostka Policji, a dla żołnierzy zawodowych - Żandarmeria Wojskowa.',
      'Termin liczy się od dnia zakupu, a nie od odbioru broni czy od wizyty w klubie. Jego przekroczenie jest naruszeniem obowiązków posiadacza broni i może skutkować konsekwencjami administracyjnymi.',
    ],
    mistake: 'Mylenie 5 dni na rejestrację z 14 dniami na zgłoszenie zmiany miejsca pobytu i 24 godzinami na zgłoszenie utraty broni. Te trzy terminy egzaminatorzy lubią zestawiać w jednym pytaniu.',
  },
  'rodzaje-broni-uznaje-sie-za-bron-palna': {
    why: 'Definicja broni palnej wyznacza zakres obowiązku rejestracji i pozwolenia, dlatego wraca w kilku wariantach w całym teście.',
    detail: [
      'Do broni palnej zalicza się broń bojową, myśliwską, sportową, gazową, alarmową i sygnałową. Lista jest szersza, niż podpowiada intuicja - broń gazowa, alarmowa i sygnałowa również mieszczą się w tej kategorii.',
      'Każdy z tych rodzajów podlega rejestracji i wymaga odpowiedniego pozwolenia, choć szczegółowe warunki różnią się w zależności od przeznaczenia broni.',
    ],
    mistake: 'Pomijanie broni alarmowej i sygnałowej przy wyliczaniu rodzajów broni palnej.',
  },
  'czym-jest-bron-pneumatyczna': {
    why: 'Broń pneumatyczna ma odrębny reżim prawny - nie wymaga pozwolenia, lecz karty rejestracyjnej, i właśnie na tym rozróżnieniu opierają się pytania.',
    detail: [
      'Bronią pneumatyczną jest urządzenie miotające pocisk energią sprężonego gazu, o energii kinetycznej pocisku przekraczającej 17 J, wyposażone w celownik i zdolne do rażenia celu na odległość.',
      'Granica 17 J jest rozstrzygająca: poniżej tej wartości urządzenie nie jest bronią pneumatyczną w rozumieniu ustawy i nie podlega rejestracji.',
    ],
    mistake: 'Podawanie energii innej niż 17 J. To konkretna liczba, której nie da się wydedukować - trzeba ją zapamiętać.',
  },
  'czym-jest-bron-szczegolnie-niebezpieczna': {
    why: 'Katalog broni szczególnie niebezpiecznej jest zamknięty i objęty bezwzględnym zakazem posiadania, dlatego pytanie pojawia się zarówno w części definicyjnej, jak i przy przepisach karnych.',
    detail: [
      'Za szczególnie niebezpieczną uznaje się broń samoczynną (strzelającą serią), broń wyposażoną w tłumik huku, broń pozbawioną cech identyfikacyjnych oraz broń z ukrytymi mechanizmami strzelania lub zamaskowaną jako inny przedmiot.',
      'Posiadanie takiej broni nie jest możliwe na podstawie zwykłego pozwolenia - to kategoria wyłączona z obrotu cywilnego.',
    ],
    mistake: 'Zaliczanie do tej kategorii broni samopowtarzalnej. Samoczynna strzela serią, samopowtarzalna - pojedynczo przy każdym naciśnięciu spustu.',
  },
  'moze-uzywac-broni-sportowej-klubu': {
    why: 'To pytanie ma bezpośrednie przełożenie na pierwsze wizyty na strzelnicy, zanim kandydat uzyska własne pozwolenie.',
    detail: [
      'Z broni należącej do klubu lub stowarzyszenia strzeleckiego mogą korzystać także osoby nieposiadające pozwolenia - pod warunkiem, że dzieje się to w ramach działalności klubu i w obecności instruktora albo innej osoby uprawnionej.',
      'To właśnie ten przepis umożliwia rozpoczęcie treningów strzeleckich przed zdobyciem patentu i licencji.',
    ],
    mistake: 'Przekonanie, że każdy może wypożyczyć broń klubową i strzelać samodzielnie. Nadzór osoby uprawnionej jest warunkiem koniecznym.',
  },
  'celow-mozna-uzywac-broni-palnej': {
    why: 'Cel użycia broni musi być zgodny z celem, na jaki wydano pozwolenie - to podstawa, na której Policja opiera decyzje o cofnięciu uprawnień.',
    detail: [
      'Broni palnej można używać do celów szkoleniowych, sportowych, rekreacyjnych oraz pokazowych, zawsze w granicach wyznaczonych przez posiadane pozwolenie.',
      'Użycie broni niezgodnie z przeznaczeniem wskazanym w decyzji jest samodzielną podstawą do obligatoryjnego cofnięcia pozwolenia.',
    ],
    mistake: 'Traktowanie pozwolenia sportowego jak uniwersalnego uprawnienia do dowolnego użycia broni.',
  },
  'moze-posiadac-bron-palna': {
    why: 'Pytanie sprawdza znajomość organów właściwych w sprawach broni - rozróżnienie Policja/Żandarmeria Wojskowa wraca później przy rejestracji i deponowaniu.',
    detail: [
      'Osoby cywilne posiadają broń palną na podstawie pozwolenia wydanego przez komendanta wojewódzkiego Policji (w Warszawie - Komendanta Stołecznego). Żołnierze zawodowi uzyskują je za zgodą właściwego komendanta Żandarmerii Wojskowej.',
      'Ten sam podział kompetencji obowiązuje przy rejestracji broni, jej deponowaniu i zgłaszaniu zmian danych.',
    ],
    mistake: 'Wskazywanie komendanta powiatowego lub miejskiego Policji. Właściwy jest komendant wojewódzki.',
  },
  'mozna-posiadac-bron-pneumatyczna': {
    why: 'To praktyczne rozróżnienie: broń pneumatyczna nie wymaga pozwolenia, lecz rejestracji, co bywa mylone z całkowitym brakiem formalności.',
    detail: [
      'Cywile posiadają broń pneumatyczną na podstawie karty rejestracyjnej wydanej przez właściwą komendę Policji, a żołnierze zawodowi - na podstawie decyzji Żandarmerii Wojskowej.',
      'Karta rejestracyjna nie jest pozwoleniem: wydaje się ją po zgłoszeniu, bez postępowania takiego jak przy broni palnej.',
    ],
    mistake: 'Twierdzenie, że broń pneumatyczna nie podlega żadnym formalnościom. Powyżej 17 J wymaga rejestracji.',
  },
  'mozna-zbywac-bron-lub-amunicje-innym-osobom': {
    why: 'Obrót między osobami prywatnymi jest dopuszczalny, ale wąsko - pytanie sprawdza, czy kandydat zna warunek zgodności pozwoleń.',
    detail: [
      'Broń i amunicję można zbyć wyłącznie osobie posiadającej pozwolenie na ten sam rodzaj broni. Sprzedaż osobie bez odpowiedniego pozwolenia jest czynem zabronionym, niezależnie od intencji stron.',
      'Po transakcji nabywca ma własny obowiązek rejestracyjny, a zbywca powinien zadbać o udokumentowanie przeniesienia własności.',
    ],
    mistake: 'Pomijanie warunku „ten sam rodzaj broni" - samo posiadanie jakiegokolwiek pozwolenia przez nabywcę nie wystarcza.',
  },
  'dozwolone-sa-przerobki-broni': {
    why: 'Zakaz przeróbek łączy część definicyjną z przepisami karnymi - przerobiona broń może stać się bronią szczególnie niebezpieczną.',
    detail: [
      'Przerabianie broni w sposób zmieniający jej rodzaj, kaliber lub przeznaczenie jest zakazane. Dotyczy to zarówno ingerencji w lufę czy komorę nabojową, jak i zmian pozwalających strzelać inną amunicją.',
      'Zakaz obejmuje również amunicję: przerobienie naboju tak, by zmienić jego pierwotne właściwości, kwalifikuje go jako amunicję szczególnie niebezpieczną.',
    ],
    mistake: 'Mylenie zakazanej przeróbki z dozwoloną wymianą części eksploatacyjnych czy montażem akcesoriów, które nie zmieniają rodzaju ani kalibru broni.',
  },
  'istotne-czesci-broni-lub-amunicji-sa-traktowane-jak-bron': {
    why: 'Pytanie wraca w kilku wariantach, bo to na nim opiera się odpowiedzialność za posiadanie samych podzespołów bez kompletnej broni.',
    detail: [
      'Istotne części broni i amunicji są w świetle przepisów traktowane tak samo jak broń lub amunicja. Podlegają więc rejestracji, kontroli i tym samym ograniczeniom w obrocie.',
      'W praktyce oznacza to, że posiadanie np. zamka czy lufy z komorą nabojową bez wymaganego pozwolenia jest równoznaczne z nielegalnym posiadaniem broni.',
    ],
    mistake: 'Założenie, że „to tylko część", więc nie podlega przepisom. Katalog istotnych części jest wyliczony wprost i warto go znać na pamięć.',
  },

  // ---------------------------------------------------------------- część 2
  'policja-moze-zobowiazac-posiadacza-pozwolenia-na-bron-do': {
    why: 'Blok pytań o badania sprawdza, czy kandydat rozumie, że pozwolenie na broń jest uprawnieniem kontrolowanym przez cały okres jego posiadania, a nie tylko na etapie wniosku.',
    detail: [
      'Policja może zobowiązać posiadacza pozwolenia do poddania się badaniom lekarskim i psychologicznym, jeżeli pojawią się uzasadnione przesłanki wskazujące na zaburzenia psychiczne, uzależnienie od alkoholu lub innych substancji albo inne okoliczności ograniczające zdolność do bezpiecznego posługiwania się bronią.',
      'Podstawą jest konkretna informacja - na przykład z interwencji, postępowania karnego lub od placówki medycznej - a nie dowolne uznanie organu.',
    ],
    mistake: 'Odpowiedź „nie, badania są tylko przy wniosku". Kontrola stanu zdrowia może nastąpić w każdym momencie posiadania pozwolenia.',
  },
  'policja-moze-ograniczyc-lub-zakazac-noszenia-broni-mimo': {
    why: 'Pytanie rozdziela dwa pojęcia, które kandydaci często łączą: posiadanie broni i jej noszenie.',
    detail: [
      'Pozwolenie na broń nie oznacza automatycznie prawa do noszenia jej przy sobie. Organ Policji może ograniczyć lub całkowicie zakazać noszenia broni, jeżeli wymaga tego bezpieczeństwo publiczne.',
      'Ograniczenie nakłada się w drodze decyzji, a jego naruszenie jest czynem zabronionym i samodzielną podstawą do cofnięcia pozwolenia.',
    ],
    mistake: 'Utożsamianie pozwolenia na posiadanie z prawem do noszenia. To dwie różne kwestie, rozstrzygane w decyzji.',
  },
  'osoba-deponujaca-bron-w-jednostce-policji-moze-ja-okazac': {
    why: 'Depozyt to sytuacja przejściowa, w której broń formalnie nadal należy do właściciela - pytanie sprawdza, co wolno z nią wtedy zrobić.',
    detail: [
      'Osoba, która zdeponowała broń w jednostce Policji, może okazać ją potencjalnemu nabywcy, ale wyłącznie po uzgodnieniu z tą jednostką. Dostęp do broni w depozycie wymaga zgody i odbywa się pod nadzorem.',
      'Rozwiązanie ma sens praktyczny: właściciel, który utracił uprawnienia, musi mieć realną możliwość sprzedaży broni osobie uprawnionej.',
    ],
    mistake: 'Odpowiedź „nie, broń w depozycie jest niedostępna". Okazanie jest możliwe - po uzgodnieniu z jednostką.',
  },
  'posiadacz-pozwolenia-sportowego-musi-dostarczac-aktualne': {
    why: 'To pytanie odróżnia obowiązki jednorazowe (przy wniosku) od cyklicznych, których w przypadku pozwolenia sportowego po prostu nie ma.',
    detail: [
      'Po uzyskaniu pozwolenia sportowego nie istnieje obowiązek okresowego dostarczania do Policji aktualnych orzeczeń lekarskich i psychologicznych. Obowiązek pojawia się dopiero wtedy, gdy organ wezwie do badań w konkretnych okolicznościach.',
      'Inaczej jest przy niektórych innych rodzajach pozwoleń oraz przy dopuszczeniu do posiadania broni - tam badania okresowe występują.',
    ],
    mistake: 'Odpowiedź „tak, co pięć lat". Dla pozwolenia sportowego cykliczny obowiązek nie występuje.',
  },
  'do-wniosku-o-wydanie-pozwolenia-na-bron-trzeba-dolaczyc': {
    why: 'Pytanie o komplet dokumentów pojawia się niemal zawsze, bo dotyczy pierwszego realnego kroku kandydata.',
    detail: [
      'Do wniosku o wydanie pozwolenia na broń dołącza się dwa orzeczenia: lekarskie oraz psychologiczne, potwierdzające brak przeciwwskazań do dysponowania bronią. Wydają je uprawnieni lekarze i psycholodzy wpisani na listy prowadzone przez komendanta wojewódzkiego Policji.',
      'Brak któregokolwiek z orzeczeń oznacza brak kompletu dokumentów i wstrzymanie biegu sprawy.',
    ],
    mistake: 'Podanie tylko orzeczenia lekarskiego. Wymagane są oba - lekarskie i psychologiczne.',
  },
  'policja-moze-cofnac-pozwolenie-osobie-uchylajacej-sie-od': {
    why: 'Domyka blok o badaniach: pokazuje, jaka jest sankcja za zignorowanie wezwania.',
    detail: [
      'Odmowa poddania się badaniom lekarskim i psychologicznym po wezwaniu przez Policję jest samodzielną podstawą cofnięcia pozwolenia na broń.',
      'Organ nie musi wykazywać, że osoba faktycznie jest niezdolna do posiadania broni - wystarczy sam fakt uchylania się od badań.',
    ],
    mistake: 'Założenie, że brak badań powoduje tylko zawieszenie uprawnień. Skutkiem jest cofnięcie pozwolenia.',
  },
  'mozna-posiadac-amunicje-wykonana-niefabrycznie': {
    why: 'Elaboracja amunicji to popularna praktyka wśród strzelców sportowych, dlatego przepis o niej jest chętnie sprawdzany.',
    detail: [
      'Amunicję wytworzoną niefabrycznie można posiadać wyłącznie na własny użytek i tylko wtedy, gdy posiada się pozwolenie na broń myśliwską, sportową lub kolekcjonerską.',
      'Obowiązuje przy tym bezwzględny zakaz zbywania takiej amunicji - nie wolno jej sprzedać ani przekazać innej osobie, nawet posiadającej pozwolenie.',
    ],
    mistake: 'Przekonanie, że skoro wolno elaborować, to wolno też sprzedać nadwyżkę. Zakaz zbywania jest bezwarunkowy.',
  },
  'kolekcjonerzy-moga-strzelac-z-posiadanej-broni': {
    why: 'Pytanie sprawdza rozumienie zasady, że każde pozwolenie ma ściśle określony cel - kolekcjonerskie służy gromadzeniu, nie strzelaniu.',
    detail: [
      'Pozwolenie kolekcjonerskie uprawnia do posiadania broni, ale nie do jej używania na strzelnicy. Do strzelania potrzebne jest odrębne pozwolenie - sportowe lub myśliwskie.',
      'To praktyczna konsekwencja zasady zgodności użycia broni z celem wskazanym w decyzji, o której mówi także pytanie o cele używania broni palnej.',
    ],
    mistake: 'Założenie, że posiadanie broni zawsze oznacza prawo do strzelania z niej. Cel pozwolenia jest rozstrzygający.',
  },
  'elementy-uwaza-sie-za-istotne-czesci-amunicji': {
    why: 'Istotne części amunicji są traktowane jak amunicja, więc od tej listy zależy legalność posiadania komponentów do elaboracji.',
    detail: [
      'Za istotne części amunicji uznaje się między innymi pociski zawierające materiały wybuchowe lub chemiczne, spłonki stanowiące inicjujący element naboju oraz proch strzelniczy.',
      'Każdy z tych elementów podlega regulacji jak amunicja, co ma znaczenie przy zakupie komponentów i ich przechowywaniu.',
    ],
    mistake: 'Mylenie istotnych części amunicji z istotnymi częściami broni. To dwie odrębne listy, o które pyta się osobno.',
  },
  'jest-istotna-czescia-broni-palnej': {
    why: 'To jedno z najczęściej powtarzanych pytań w całym zestawie, bo posiadanie tych elementów bez pozwolenia jest przestępstwem.',
    detail: [
      'Do istotnych części broni palnej należą: szkielet broni, baskila, lufa z komorą nabojową, zamek, komora zamkowa oraz bęben nabojowy.',
      'Wszystkie są traktowane jak broń, a więc podlegają rejestracji i wymagają pozwolenia. Posiadanie ich bez uprawnień odpowiada nielegalnemu posiadaniu broni.',
    ],
    mistake: 'Zaliczanie do istotnych części kolby, chwytu, magazynka czy przyrządów celowniczych - to elementy nieistotne w rozumieniu ustawy.',
  },
  'nalezy-zrobic-z-bronia-po-utracie-uprawnien-do-jej': {
    why: 'Pytanie o termin 30 dni pojawia się często w parze z pytaniem o obowiązek zbycia broni - warto znać oba rozwiązania.',
    detail: [
      'Po utracie uprawnień broń i amunicję należy zdeponować w jednostce Policji. Ustawa daje na to 30 dni od dnia utraty uprawnień.',
      'Niedopełnienie tego obowiązku jest wykroczeniem. Depozyt nie oznacza utraty własności - broń pozostaje własnością dotychczasowego posiadacza, który może ją następnie zbyć osobie uprawnionej.',
    ],
    mistake: 'Mylenie 30 dni na zdeponowanie broni z 5 dniami na rejestrację i 14 dniami na zgłoszenie zmiany miejsca pobytu.',
  },
  'typy-broni-mieszcza-sie-w-definicji-broni-palnej': {
    why: 'Powtórzenie definicji z części pierwszej - egzamin celowo wraca do niej w innym ujęciu.',
    detail: [
      'Definicja obejmuje broń bojową, myśliwską, sportową, gazową, alarmową i sygnałową. Wszystkie te rodzaje podlegają rejestracji i wymagają odpowiedniego pozwolenia.',
      'Warto zapamiętać całą szóstkę jako zamkniętą listę - pytania często podają cztery lub pięć pozycji i sprawdzają, czy zauważysz brak.',
    ],
    mistake: 'Wykluczanie broni gazowej i alarmowej z definicji broni palnej.',
  },
  'wieku-mozna-uzyskac-pozwolenie-na-bron-do-celow-sportowych': {
    why: 'Wiek to klasyczne pytanie „liczbowe", a dodatkowo pokazuje wyjątek od reguły ogólnej.',
    detail: [
      'Pozwolenie na broń do celów sportowych lub łowieckich można uzyskać po ukończeniu 18 lat, na wniosek szkoły, organizacji sportowej, Polskiego Związku Łowieckiego lub stowarzyszenia obronnego.',
      'To wyjątek od zasady ogólnej, według której pozwolenie wydaje się osobom, które ukończyły 21 lat.',
    ],
    mistake: 'Podawanie 21 lat dla celów sportowych. Dla sportu i łowiectwa granicą jest 18 lat - przy wniosku właściwej organizacji.',
  },
  'nalezy-zarejestrowac-nowo-nabyta-bron': {
    why: 'Ten sam termin pojawia się w części pierwszej - powtórzenie nie jest przypadkiem, bo to jedna z najczęściej mylonych liczb.',
    detail: [
      'Nowo nabytą broń rejestruje się w ciągu 5 dni od daty zakupu we właściwej jednostce Policji, a w przypadku żołnierzy zawodowych - w Żandarmerii Wojskowej.',
      'Termin jest nieprzekraczalny i liczy się od nabycia, niezależnie od tego, kiedy broń trafiła do rąk kupującego.',
    ],
    mistake: 'Podawanie 14 lub 30 dni. Rejestracja to 5 dni.',
  },
  'jest-zwolniony-z-egzaminu-na-patent-strzelecki': {
    why: 'Pytanie praktyczne - część kandydatów nie musi w ogóle przystępować do egzaminu i warto wiedzieć, czy się do nich należy.',
    detail: [
      'Ze zdawania egzaminu zwolnieni są funkcjonariusze Policji, Wojska Polskiego oraz służb, którzy zdali egzamin ze znajomości przepisów i umiejętności posługiwania się bronią na podstawie odrębnych przepisów, a także członkowie PZSS posiadający licencję strzelecką uzyskaną w tym trybie.',
      'Zwolnienie dotyczy egzaminu, a nie pozostałych warunków formalnych - te trzeba spełnić tak samo.',
    ],
    mistake: 'Rozciąganie zwolnienia na wszystkich członków klubów strzeleckich. Liczy się licencja i egzamin zdany na podstawie odrębnych przepisów.',
  },
  'jest-oplata-za-egzamin-strzelecki': {
    why: 'Konkretna kwota z konkretnej ustawy - pytanie sprawdza pamięć do liczb, a nie rozumienie zasad.',
    detail: [
      'Opłata za egzamin na patent strzelecki wynosi 400 zł i wynika z ustawy z 25 czerwca 2010 r. o sporcie.',
      'Jest jednorazowa i obowiązkowa; wnosi się ją przed przystąpieniem do egzaminu, niezależnie od jego wyniku.',
    ],
    mistake: 'Mylenie opłaty egzaminacyjnej z opłatą za licencję zawodniczą PZSS albo ze składką klubową - to trzy różne płatności.',
  },

  // ---------------------------------------------------------------- część 3
  'policja-obligatoryjnie-cofa-pozwolenie-na-bron': {
    why: 'Rozróżnienie „musi cofnąć" od „może cofnąć" to jedno z ulubionych pytań egzaminatorów.',
    detail: [
      'Obligatoryjne cofnięcie reguluje art. 18 ust. 1 i jest to katalog zamknięty: naruszenie warunków z art. 10 ust. 7 dotyczących noszenia broni, przynależność do osób z art. 15 ust. 1 pkt 2-6, naruszenie 24-godzinnego obowiązku zawiadomienia o utracie broni z art. 25 oraz przemieszczanie się z rozładowaną bronią lub noszenie jej po użyciu alkoholu albo środka odurzającego.',
      'Fakultatywne cofnięcie to art. 18 ust. 4 i 5. Najważniejszy jest ust. 4: organ może cofnąć pozwolenie, jeżeli ustały okoliczności faktyczne, które stanowiły podstawę jego wydania - to na tej podstawie ocenia się na przykład utratę członkostwa w stowarzyszeniu.',
    ],
    mistake: 'Traktowanie wszystkich naruszeń jednakowo. Część skutkuje cofnięciem obowiązkowo, część zależy od oceny organu. Uwaga na utratę członkostwa w klubie: nie ma jej w katalogu obligatoryjnym, wchodzi pod uznaniowy art. 18 ust. 4.',
  },
  'nalezy-zglosic-zmiane-miejsca-stalego-pobytu': {
    why: 'Kolejny termin do zapamiętania, tym razem 14-dniowy - i kolejna okazja, by pomylić go z pozostałymi.',
    detail: [
      'Zmianę miejsca stałego pobytu posiadacz broni zgłasza pisemnie w terminie 14 dni, organowi Policji właściwemu dla nowego miejsca zamieszkania.',
      'Obowiązek wynika z konieczności aktualizacji ewidencji - to organ właściwy miejscowo prowadzi sprawy posiadacza broni i wykonuje kontrole warunków przechowywania.',
    ],
    mistake: 'Zgłaszanie zmiany w dotychczasowej jednostce zamiast w nowej, właściwej dla nowego adresu.',
  },
  'nalezy-zrobic-po-utracie-uprawnien-do-posiadania-broni': {
    why: 'Pytanie uzupełnia wątek depozytu z części drugiej - tu chodzi o obowiązek zbycia broni.',
    detail: [
      'Osoba, która utraciła uprawnienia, traci prawo do posiadania broni i powinna niezwłocznie zbyć ją wraz z amunicją - sprzedać lub przekazać osobie posiadającej stosowne pozwolenie.',
      'Alternatywą pozostaje zdeponowanie broni w jednostce Policji, co daje czas na znalezienie nabywcy.',
    ],
    mistake: 'Przechowywanie broni „do wyjaśnienia sprawy". Po utracie uprawnień broń musi trafić do depozytu albo do osoby uprawnionej.',
  },
  'naruszenie-ograniczenia-noszenia-broni-jest-przestepstwem': {
    why: 'Domyka wątek ograniczeń noszenia z części drugiej, pokazując konsekwencje ich złamania.',
    detail: [
      'Noszenie broni wbrew zakazowi lub ograniczeniu nałożonemu przez organ Policji jest czynem zabronionym.',
      'Poza odpowiedzialnością wynikającą z przepisów karnych naruszenie stanowi podstawę do cofnięcia pozwolenia na broń.',
    ],
    mistake: 'Traktowanie ograniczenia noszenia jako zalecenia. To wiążąca decyzja administracyjna.',
  },
  'nalezy-przechowywac-bron-i-amunicje': {
    why: 'Warunki przechowywania są kontrolowane przez Policję w miejscu zamieszkania, więc pytanie ma wymiar czysto praktyczny.',
    detail: [
      'Broń i amunicję przechowuje się w stalowych kasetach, szafach lub sejfach spełniających wymagane normy, trwale przymocowanych do elementów konstrukcyjnych budynku.',
      'Chodzi o uniemożliwienie dostępu osobom nieuprawnionym oraz wyniesienia całego magazynku wraz z zawartością - stąd wymóg mocowania.',
    ],
    mistake: 'Uznanie zwykłej zamykanej szafki lub biurka za wystarczające zabezpieczenie.',
  },
  'nalezy-zglosic-utrate-broni': {
    why: 'Najkrótszy z terminów w całym zestawie - 24 godziny - i dlatego najłatwiejszy do pomylenia z pozostałymi.',
    detail: [
      'Utratę broni zgłasza się niezwłocznie, nie później niż w ciągu 24 godzin od chwili stwierdzenia jej utraty, Policji lub Żandarmerii Wojskowej.',
      'Termin biegnie od momentu stwierdzenia utraty, a nie od jej faktycznego zaistnienia - liczy się chwila, w której posiadacz się o niej dowiedział.',
    ],
    mistake: 'Podawanie 5 lub 14 dni. Utrata broni to 24 godziny.',
  },
  'nie-moze-otrzymac-pozwolenia-na-bron': {
    why: 'Pytanie o przesłanki negatywne - kto jest z góry wykluczony z możliwości uzyskania pozwolenia.',
    detail: [
      'Pozwolenia nie wydaje się osobom niemającym ukończonych 21 lat (z wyjątkiem celów sportowych i łowieckich - tam granicą jest 18 lat) oraz osobom z zaburzeniami psychicznymi lub o istotnie ograniczonej sprawności psychofizycznej.',
      'Przesłanki te bada się na etapie orzeczeń lekarskiego i psychologicznego dołączanych do wniosku.',
    ],
    mistake: 'Pomijanie wyjątku wiekowego dla sportu i łowiectwa przy pytaniu o granicę wieku.',
  },
  'w-jakich-przypadkach-pozwolenie-na-bron-nie-jest-wymagane': {
    why: 'Lista wyjątków jest długa i chętnie sprawdzana, bo pokazuje granice obowiązku uzyskania pozwolenia.',
    detail: [
      'Pozwolenie nie jest wymagane między innymi przy posiadaniu broni muzealnej, korzystaniu z broni na strzelnicy w ramach działalności klubu, broni alarmowej o kalibrze do 6 mm, broni pozbawionej cech użytkowych oraz broni czarnoprochowej rozdzielnego ładowania wytworzonej przed 1885 r. i jej replik.',
      'Brak wymogu pozwolenia nie zawsze oznacza brak obowiązku rejestracji - te dwie kwestie reguluje się osobno.',
    ],
    mistake: 'Zapominanie o granicy 6 mm przy broni alarmowej - powyżej tego kalibru pozwolenie jest już wymagane.',
  },
  'jest-minimalny-wiek-do-uzyskania-pozwolenia-z-wyjatkiem': {
    why: 'Druga strona pytania o wiek - tu chodzi o zasadę ogólną, a nie o wyjątek sportowo-łowiecki.',
    detail: [
      'Co do zasady pozwolenie na broń wydaje się osobom, które ukończyły 21 lat. Wymóg ma zapewnić odpowiedni poziom dojrzałości i odpowiedzialności posiadacza.',
      'Wyjątkiem są cele sportowe i łowieckie, gdzie granica wynosi 18 lat, o ile z wnioskiem wystąpi właściwa organizacja.',
    ],
    mistake: 'Podawanie jednej uniwersalnej granicy wieku. Egzamin sprawdza właśnie znajomość obu wartości i relacji między nimi.',
  },
  'do-czego-uprawnia-pozwolenie-na-bron-sportowa': {
    why: 'Pytanie o zakres pozwolenia sportowego - istotne dla każdego, kto zdaje patent właśnie w tym celu.',
    detail: [
      'Pozwolenie na broń sportową obejmuje między innymi broń palną bocznego zapłonu z lufami gwintowanymi o kalibrze do 6 mm.',
      'Zakres pozwolenia wyznacza jednocześnie zakres amunicji, którą wolno nabywać na podstawie legitymacji posiadacza broni.',
    ],
    mistake: 'Mylenie kalibru do 6 mm dla broni bocznego zapłonu z granicą 6 mm dla broni alarmowej, przy której pozwolenie nie jest wymagane.',
  },
  'mozna-przesylac-bron-i-amunicje-kurierem': {
    why: 'Praktyczne pytanie o obrót - odpowiedź brzmi „tak, ale", i właśnie to zastrzeżenie jest sprawdzane.',
    detail: [
      'Przesyłanie broni i amunicji jest dopuszczalne wyłącznie za pośrednictwem podmiotów wyspecjalizowanych w przewozie tego rodzaju towarów i posiadających wymagane zezwolenia.',
      'Nie wolno nadać broni zwykłą przesyłką kurierską ani pocztową - to naruszenie przepisów o obrocie.',
    ],
    mistake: 'Odpowiedź „nie, nigdy". Przesyłka jest możliwa, ale tylko przez uprawnionego przewoźnika.',
  },
  'dokumenty-sa-potrzebne-do-przywozu-broni-spoza-ue': {
    why: 'Pytanie dotyczy sytuacji rzadkiej, ale jednoznacznie uregulowanej - dlatego dobrze nadaje się na test.',
    detail: [
      'Obywatel polski przywożący broń spoza Unii Europejskiej musi posiadać zaświadczenie wydane przez właściwego konsula Rzeczypospolitej Polskiej.',
      'Brak zaświadczenia skutkuje niedopuszczeniem broni do wwozu na terytorium kraju.',
    ],
    mistake: 'Wskazywanie Europejskiej karty broni palnej. Ta dotyczy przemieszczania broni wewnątrz Unii, a nie przywozu spoza niej.',
  },
  'na-podstawie-jakiego-dokumentu-rejestruje-sie-bron': {
    why: 'Uzupełnia blok o rejestracji: znamy już termin, teraz chodzi o podstawę dokumentową.',
    detail: [
      'Rejestracji broni dokonuje się na podstawie dowodu nabycia - faktury, umowy sprzedaży lub innego dokumentu potwierdzającego przeniesienie własności.',
      'Rejestruje właściwy organ Policji, a w przypadku żołnierzy zawodowych - Żandarmeria Wojskowa.',
    ],
    mistake: 'Wskazywanie zaświadczenia uprawniającego do zakupu jako podstawy rejestracji. Ono uprawnia do nabycia, rejestracja opiera się na dowodzie nabycia.',
  },
  'grozi-za-niezgloszenie-zamiaru-wywozu-broni-za-granice': {
    why: 'Pytanie łączy obowiązki informacyjne z sankcją - typowy schemat w tej części materiału.',
    detail: [
      'Wywóz broni za granicę wymaga uzyskania wymaganej zgody. Naruszenie tego obowiązku Policja traktuje jako poważne naruszenie przepisów.',
      'Konsekwencją może być cofnięcie pozwolenia na broń, niezależnie od ewentualnej odpowiedzialności wynikającej z przepisów celnych.',
    ],
    mistake: 'Zakładanie, że skoro broń jest zarejestrowana w Polsce, jej wywóz nie wymaga dodatkowych formalności.',
  },
  'grozi-za-uzyczenie-broni-osobie-nieuprawnionej': {
    why: 'To pytanie pojawia się także w części o przepisach karnych - warto zapamiętać rodzaj sankcji.',
    detail: [
      'Użyczenie broni osobie nieuprawnionej jest czynem zabronionym zagrożonym karą grzywny albo aresztu.',
      'Wyjątkiem pozostaje korzystanie z broni klubowej pod nadzorem osoby uprawnionej w ramach działalności klubu - tam ustawa wprost dopuszcza udostępnienie broni.',
    ],
    mistake: 'Mylenie użyczenia broni osobie nieuprawnionej z legalnym udostępnieniem broni klubowej pod nadzorem instruktora.',
  },

  // ---------------------------------------------------------------- część 4
  'uznaje-sie-za-wazna-przyczyne-wydania-pozwolenia-sportowego': {
    why: '„Ważna przyczyna" to pojęcie, od którego zależy powodzenie całego wniosku - organ bada je jako pierwsze.',
    detail: [
      'Przy pozwoleniu do celów sportowych ważną przyczyną jest udokumentowane uprawianie sportu strzeleckiego: przynależność do klubu, posiadanie patentu i licencji zawodniczej PZSS oraz udział w zawodach.',
      'Sama chęć posiadania broni nie jest ważną przyczyną. Dlatego kolejność jest stała: klub, patent, licencja, starty, dopiero potem wniosek o pozwolenie.',
    ],
    mistake: 'Uznanie, że wystarczy zapisać się do klubu. Organ oczekuje udokumentowanej aktywności sportowej, nie samego członkostwa.',
  },
  'co-potwierdza-zarejestrowanie-broni': {
    why: 'Pytanie rozróżnia dwa dokumenty, które kandydaci często mylą - legitymację i świadectwo broni.',
    detail: [
      'Zarejestrowanie broni potwierdza legitymacja posiadacza broni (dla osób fizycznych) albo świadectwo broni (dla podmiotów, np. klubów i firm).',
      'Legitymacja przypisana jest do konkretnej osoby i wskazuje egzemplarze broni, które ta osoba może posiadać oraz amunicję, jaką może nabywać.',
    ],
    mistake: 'Traktowanie świadectwa broni jako dokumentu dla osoby fizycznej. Świadectwo dotyczy podmiotów, nie osób prywatnych.',
  },
  'dlugo-wazna-jest-legitymacja-uprawniajaca-do-nabycia-broni': {
    why: 'Kolejny termin liczbowy - 3 miesiące - zestawiany na egzaminie z terminami 5 dni, 14 dni i 24 godzin.',
    detail: [
      'Dokument uprawniający do nabycia broni, wydany przez właściwy organ Policji, zachowuje ważność przez 3 miesiące od dnia wystawienia.',
      'Po upływie tego okresu traci moc i konieczne jest wystąpienie o nowy, jeżeli zakup nie doszedł do skutku.',
    ],
    mistake: 'Podawanie 30 dni lub 6 miesięcy. Obowiązuje termin 3 miesięcy.',
  },
  'dlugo-wazne-jest-swiadectwo-do-nabycia-broni': {
    why: 'Pytanie bliźniacze do poprzedniego - ten sam termin, inny dokument, i właśnie dlatego bywa mylone.',
    detail: [
      'Świadectwo uprawniające do nabycia określonej sztuki broni palnej jest ważne przez 3 miesiące od dnia wystawienia.',
      'Jeżeli w tym czasie zakup i rejestracja nie zostaną sfinalizowane, dokument wygasa i procedurę trzeba powtórzyć.',
    ],
    mistake: 'Zakładanie, że po zakupie broni w ostatnim dniu ważności nie ma już żadnych terminów. Pozostaje jeszcze 5 dni na rejestrację.',
  },
  'trzeba-zglosic-zaginiecie-broni': {
    why: 'Najkrótszy termin w całym materiale, powtarzany w kilku częściach - egzaminatorzy sprawdzają go bardzo chętnie.',
    detail: [
      'Zaginięcie lub utratę broni zgłasza się niezwłocznie, najpóźniej w ciągu 24 godzin od stwierdzenia tego faktu, właściwemu organowi Policji.',
      'Szybkie zgłoszenie ma znaczenie praktyczne: pozwala wpisać broń do ewidencji utraconych, zanim trafi w niepowołane ręce.',
    ],
    mistake: 'Liczenie terminu od chwili zaginięcia, a nie od momentu, w którym posiadacz je stwierdził.',
  },
  'moze-przebywac-na-stanowisku-strzeleckim': {
    why: 'Zasada porządkowa, ale sprawdzana na egzaminie praktycznym - to od niej zaczyna się bezpieczeństwo na osi.',
    detail: [
      'Na stanowiskach strzeleckich mogą przebywać wyłącznie osoby aktualnie realizujące strzelanie oraz prowadzący strzelanie i osoby przez niego dopuszczone.',
      'Osoby postronne, obserwatorzy i oczekujący pozostają w strefie wyznaczonej regulaminem strzelnicy, poza linią stanowisk.',
    ],
    mistake: 'Wchodzenie na stanowisko, żeby obejrzeć wynik kolegi. Ruch na osi odbywa się wyłącznie na komendę prowadzącego.',
  },
  'bron-powinna-byc-przechowywana-poza-stanowiskiem': {
    why: 'Pytanie o stan broni poza stanowiskiem to podstawa oceny na egzaminie praktycznym.',
    detail: [
      'Poza stanowiskiem strzeleckim broń musi być rozładowana, z otwartą komorą nabojową, bez magazynka, ułożona lub przenoszona tak, by jej stan był widoczny dla otoczenia.',
      'Widoczność otwartej komory jest istotą tej zasady - pozwala każdemu na strzelnicy potwierdzić wzrokiem, że broń jest bezpieczna.',
    ],
    mistake: 'Zamknięcie zamka „dla porządku" po zakończeniu strzelania. Komora ma pozostać otwarta.',
  },
  'przewozic-bron-w-komunikacji-publicznej': {
    why: 'Transport publiczny to sytuacja, w której najłatwiej naruszyć przepisy - stąd osobne pytania na egzaminie.',
    detail: [
      'Broń przewożona środkami transportu publicznego musi być całkowicie rozładowana: pusta komora nabojowa i puste magazynki.',
      'Powinna znajdować się w futerale lub pokrowcu uniemożliwiającym dostęp osobom nieuprawnionym i przypadkowe użycie, a także niezwracającym uwagi otoczenia.',
    ],
    mistake: 'Przewożenie broni z amunicją w tym samym, niezabezpieczonym opakowaniu.',
  },
  'zabezpieczyc-bron-sportowa-w-transporcie-publicznym': {
    why: 'Uzupełnia poprzednie pytanie o wymóg zabezpieczenia - egzamin sprawdza obie strony tej samej zasady.',
    detail: [
      'Broń sportowa w transporcie publicznym musi być zabezpieczona w sposób uniemożliwiający jej przypadkowe użycie oraz dostęp osób nieuprawnionych.',
      'W praktyce oznacza to zamknięty futerał lub walizkę transportową, przewożone pod stałą kontrolą posiadacza.',
    ],
    mistake: 'Pozostawienie futerału z bronią bez nadzoru, np. na półce bagażowej poza zasięgiem wzroku.',
  },
  'dokumenty-trzeba-miec-przy-przewozie-broni-sportowej': {
    why: 'Kontrola dokumentów jest typową sytuacją podczas przewozu broni - warto wiedzieć, co trzeba okazać.',
    detail: [
      'Przy przewozie broni sportowej należy mieć przy sobie legitymację posiadacza broni oraz - w kontekście sportowym - licencję zawodniczą PZSS.',
      'Dokumenty potwierdzają zarówno uprawnienie do posiadania konkretnej broni, jak i cel jej przewożenia.',
    ],
    mistake: 'Poleganie wyłącznie na dowodzie osobistym. Legitymacja posiadacza broni jest dokumentem niezbędnym.',
  },
  'mozna-korzystac-z-cudzej-broni-na-strzelnicy': {
    why: 'Pytanie łączy zasady regulaminowe z odpowiedzialnością - dotykanie cudzej broni jest jednym z klasycznych naruszeń.',
    detail: [
      'Korzystanie z broni należącej do innej osoby jest możliwe wyłącznie za jej wyraźną zgodą i przy zachowaniu wszystkich zasad bezpieczeństwa.',
      'Użytkownik cudzej broni odpowiada za sposób posługiwania się nią tak samo jak za własną.',
    ],
    mistake: 'Sięganie po broń leżącą na stanowisku bez pytania właściciela - to naruszenie regulaminu każdej strzelnicy.',
  },
  'na-strzelnicy-wolno-spozywac-alkohol-lub-srodki-odurzajace': {
    why: 'Zakaz jest bezwzględny i ma bezpośrednie przełożenie na odpowiedzialność karną, o której mówi część dziewiąta.',
    detail: [
      'Na terenie strzelnicy obowiązuje bezwzględny zakaz spożywania alkoholu oraz przebywania pod wpływem środków odurzających i psychotropowych.',
      'Osoba naruszająca zakaz zostaje natychmiast usunięta ze strzelnicy, a sprawa może zakończyć się cofnięciem pozwolenia na broń.',
    ],
    mistake: 'Przekonanie, że zakaz dotyczy tylko osoby strzelającej. Obejmuje wszystkich przebywających na terenie obiektu.',
  },
  'mozna-wyjac-bron-na-strzelnicy': {
    why: 'Miejsce wyjęcia broni z futerału to jedno z pierwszych zachowań ocenianych przez prowadzącego strzelanie.',
    detail: [
      'Broń wolno wyjąć z futerału lub kabury wyłącznie na stanowisku strzeleckim, bezpośrednio przed rozpoczęciem strzelania, z lufą skierowaną w stronę kulochwytu.',
      'Manipulowanie bronią poza stanowiskiem - w szatni, na parkingu czy w strefie odpoczynku - jest zabronione.',
    ],
    mistake: 'Rozpakowywanie broni przy stole poza linią stanowisk, żeby „przygotować sprzęt".',
  },

  // ---------------------------------------------------------------- część 5
  'moze-wydac-komende-stop': {
    why: 'To najważniejsza zasada bezpieczeństwa na strzelnicy i pytanie, które pojawia się praktycznie zawsze.',
    detail: [
      'Komendę „STOP" może wydać każda osoba znajdująca się na strzelnicy, jeśli zauważy sytuację zagrażającą bezpieczeństwu - nie tylko prowadzący strzelanie.',
      'Zasada ta ma pierwszeństwo przed wszystkimi innymi: po jej usłyszeniu wszyscy natychmiast przerywają czynności, niezależnie od etapu strzelania.',
    ],
    mistake: 'Odpowiedź „tylko prowadzący strzelanie". Uprawnienie przysługuje każdemu obecnemu na obiekcie.',
  },
  'mozna-przyprowadzic-zwierzeta-na-strzelnice': {
    why: 'Pytanie porządkowe, ale realne - regulaminy strzelnic muszą rozstrzygać obecność zwierząt.',
    detail: [
      'Zwierzęta mogą przebywać na terenie strzelnicy wyłącznie pod nadzorem opiekuna i na uwięzi, o ile regulamin obiektu tego nie wyklucza.',
      'Opiekun odpowiada za to, by obecność zwierzęcia nie zakłócała strzelania ani nie stwarzała ryzyka dla uczestników.',
    ],
    mistake: 'Odpowiedź „całkowity zakaz". Zwierzęta są dopuszczalne pod nadzorem i na uwięzi.',
  },
  'co-oznacza-komenda-rozladuj': {
    why: 'Znajomość komend to podstawa egzaminu praktycznego - każdą trzeba umieć wykonać bez zastanowienia.',
    detail: [
      'Na komendę „ROZŁADUJ" należy wyjąć magazynek, usunąć nabój z komory nabojowej, otworzyć zamek i pozostawić broń w bezpiecznym kierunku, lufą w stronę kulochwytu.',
      'Prowadzący strzelanie sprawdza następnie wzrokowo, czy komora jest pusta - dlatego zamek pozostaje otwarty.',
    ],
    mistake: 'Wyjęcie magazynka bez usunięcia naboju z komory. To najczęstsza i najgroźniejsza pomyłka.',
  },
  'mozna-zostawic-zaladowana-bron-podczas-przerwy': {
    why: 'Pytanie sprawdza rozumienie zasady, że broń bez nadzoru musi być zawsze rozładowana.',
    detail: [
      'Pozostawienie załadowanej broni bez kontroli jest bezwzględnie zabronione, nawet na krótką chwilę i nawet na stanowisku strzeleckim.',
      'Na czas przerwy broń musi zostać rozładowana, z otwartą komorą, odłożona w miejscu i w sposób wskazanym przez prowadzącego.',
    ],
    mistake: 'Założenie, że zabezpieczenie broni bezpiecznikiem wystarczy. Wymagane jest rozładowanie.',
  },
  'prawidlowo-odkladac-bron-w-trakcie-konkurencji': {
    why: 'Sposób odkładania broni jest oceniany na egzaminie praktycznym i bywa powodem niezaliczenia.',
    detail: [
      'Broń odkłada się po rozładowaniu: bez magazynka, z usuniętym nabojem, z otwartym zamkiem i lufą skierowaną w stronę tarcz.',
      'Ułożenie broni ma umożliwiać prowadzącemu kontrolę stanu komory bez podnoszenia broni ze stanowiska.',
    ],
    mistake: 'Odkładanie broni lufą w bok lub w stronę stanowisk sąsiednich.',
  },
  'robic-natychmiast-po-uslyszeniu-komendy-stop': {
    why: 'Druga strona pytania o komendę „STOP" - tu chodzi o reakcję, a nie o uprawnienie do jej wydania.',
    detail: [
      'Po komendzie „STOP" należy natychmiast przerwać strzelanie, zdjąć palec ze spustu, zabezpieczyć broń i skierować lufę w bezpiecznym kierunku, czekając na dalsze polecenia.',
      'Nie wolno opuszczać stanowiska ani manipulować bronią do czasu wydania kolejnej komendy przez prowadzącego.',
    ],
    mistake: 'Dokończenie rozpoczętej serii „bo został jeden nabój". Komendę wykonuje się natychmiast.',
  },
  'co-oznacza-komenda-laduj': {
    why: 'Komenda „ŁADUJ" jest często zestawiana z „OGIEŃ" - egzamin sprawdza, czy kandydat nie myli tych etapów.',
    detail: [
      'Na komendę „ŁADUJ" należy załadować magazynek, wprowadzić go do broni i dosłać nabój do komory nabojowej, pozostając w gotowości.',
      'Po tej komendzie nie wolno jeszcze oddać strzału - strzelanie rozpoczyna się dopiero na komendę „OGIEŃ" lub „START".',
    ],
    mistake: 'Rozpoczęcie strzelania bezpośrednio po „ŁADUJ". To poważne naruszenie zasad bezpieczeństwa.',
  },
  'strzelanie-na-sucho-jest-dozwolone': {
    why: 'Trening bez amunicji jest powszechny, ale obwarowany warunkami - i o te warunki pyta egzamin.',
    detail: [
      'Strzelanie „na sucho", czyli bez amunicji, jest dozwolone wyłącznie w miejscu wyznaczonym przez regulamin i za wyraźną zgodą prowadzącego strzelanie.',
      'Broń musi być przy tym rozładowana i skierowana w bezpiecznym kierunku, a w pobliżu nie może znajdować się amunicja.',
    ],
    mistake: 'Ćwiczenie „na sucho" na stanowisku w trakcie przerwy, bez zgody prowadzącego.',
  },
  'osoba-naruszajaca-regulamin-moze-zostac-usunieta-ze': {
    why: 'Pytanie o uprawnienia prowadzącego strzelanie - kluczowe dla zrozumienia, kto odpowiada za porządek na osi.',
    detail: [
      'Prowadzący strzelanie ma prawo natychmiast usunąć ze strzelnicy osobę naruszającą regulamin lub zasady bezpieczeństwa.',
      'Decyzja nie wymaga zgody osoby zainteresowanej ani zarządu klubu - prowadzący odpowiada za bezpieczeństwo w czasie strzelania.',
    ],
    mistake: 'Przekonanie, że usunięcie wymaga decyzji zarządu obiektu.',
  },
  'trzeba-zrobic-z-bronia-po-zakonczeniu-strzelania': {
    why: 'Procedura zakończenia strzelania jest tak samo ważna jak jego rozpoczęcie - tu najczęściej dochodzi do niekontrolowanych strzałów.',
    detail: [
      'Po zakończeniu strzelania broń należy rozładować, otworzyć komorę nabojową i przedstawić ją do kontroli prowadzącemu.',
      'Stanowisko wolno opuścić dopiero po zatwierdzeniu stanu broni przez prowadzącego strzelanie.',
    ],
    mistake: 'Zejście ze stanowiska z bronią przed kontrolą, „bo i tak jest rozładowana".',
  },
  'komenda-przerywa-sie-strzelanie': {
    why: 'Powtórzenie kluczowej komendy w innym ujęciu - egzamin celowo wraca do niej kilka razy.',
    detail: [
      'Strzelanie przerywa się komendą „STOP". Jest to sygnał natychmiastowego wstrzymania wszystkich czynności na osi.',
      'Komendy nie wolno ignorować pod żadnym pozorem, niezależnie od tego, kto ją wydał.',
    ],
    mistake: 'Podawanie komendy „PRZERWIJ OGIEŃ" jako uniwersalnej. Obowiązującym sygnałem alarmowym jest „STOP".',
  },
  'kiedy-nalezy-rozladowac-bron': {
    why: 'Pytanie o moment rozładowania spina wcześniejsze komendy w jedną, praktyczną zasadę.',
    detail: [
      'Broń rozładowuje się bezpośrednio po zakończeniu serii lub na komendę „ROZŁADUJ", niezależnie od tego, jak krótko trwało strzelanie.',
      'Rozładowanie następuje również przed każdą przerwą, przed opuszczeniem stanowiska i przed schowaniem broni do futerału.',
    ],
    mistake: 'Odkładanie rozładowania „na później", gdy strzelanie ma zaraz być wznowione.',
  },
  'dokladnie-zrobic-po-laduj': {
    why: 'Uszczegółowienie komendy „ŁADUJ" - egzaminatorzy sprawdzają całą sekwencję czynności, nie tylko jej nazwę.',
    detail: [
      'Po komendzie „ŁADUJ" należy załadować broń, wprowadzić nabój do komory nabojowej, zabezpieczyć broń i oczekiwać na sygnał do rozpoczęcia ognia.',
      'Przez cały ten czas lufa pozostaje skierowana w stronę kulochwytu, a palec poza językiem spustowym.',
    ],
    mistake: 'Trzymanie palca na spuście w oczekiwaniu na komendę „OGIEŃ".',
  },
  'jak-wyglada-zakonczenie-strzelania': {
    why: 'Pełna procedura końcowa - od rozładowania po przeniesienie broni poza stanowisko.',
    detail: [
      'Zakończenie strzelania obejmuje rozładowanie broni, przedstawienie jej do kontroli, a następnie przenoszenie z otwartą komorą nabojową i bez magazynka.',
      'Dopiero po opuszczeniu strefy stanowisk broń można schować do futerału.',
    ],
    mistake: 'Zamknięcie zamka i schowanie broni do futerału jeszcze na stanowisku, przed kontrolą.',
  },
  'mozna-celowac-do-przypadkowych-przedmiotow': {
    why: 'Kierowanie broni wyłącznie w stronę wyznaczonych celów to zasada, której naruszenie kończy egzamin natychmiast.',
    detail: [
      'Broń wolno kierować wyłącznie w stronę celów wyznaczonych przez organizatora strzelania oraz w bezpiecznym kierunku wskazanym regulaminem.',
      'Celowanie w ludzi, zwierzęta czy przypadkowe przedmioty jest najpoważniejszym naruszeniem zasad bezpieczeństwa, także wtedy, gdy broń jest rozładowana.',
    ],
    mistake: 'Traktowanie broni rozładowanej jako „bezpiecznej" i celowanie nią dla żartu.',
  },
  'podstawowe-obowiazki-prowadzacego-strzelanie': {
    why: 'Prowadzący strzelanie odpowiada za bezpieczeństwo całej osi - pytanie sprawdza znajomość zakresu tej odpowiedzialności.',
    detail: [
      'Do obowiązków prowadzącego należy czuwanie nad bezpieczeństwem uczestników, kontrola stanu broni, wydawanie komend oraz prowadzenie książki rejestru pobytu na strzelnicy.',
      'Prowadzący może w każdej chwili przerwać strzelanie, a także wykluczyć uczestnika naruszającego zasady.',
    ],
    mistake: 'Pomijanie obowiązku prowadzenia książki rejestru - to zadanie formalne, ale wymieniane wprost w regulaminie.',
  },
  'zapoznanie-sie-z-regulaminem-jest-obowiazkowe': {
    why: 'Formalność, o którą pyta się, bo dotyczy każdego wejścia na strzelnicę - także osób doświadczonych.',
    detail: [
      'Każdy uczestnik strzelania musi zapoznać się z regulaminem strzelnicy i potwierdzić to podpisem, niezależnie od stażu i posiadanych uprawnień.',
      'Bez tego potwierdzenia nie można rozpocząć strzelania - regulamin określa m.in. dopuszczalne kierunki strzałów i strefy bezpieczeństwa danego obiektu.',
    ],
    mistake: 'Zakładanie, że regulamin podpisuje się raz na zawsze albo że nie dotyczy stałych bywalców.',
  },
  'zachowania-sa-bezwzglednie-zakazane': {
    why: 'Zbiorcze pytanie o naruszenia - dobre podsumowanie całej części o bezpieczeństwie.',
    detail: [
      'Bezwzględnie zakazane jest dotykanie cudzej broni bez zgody właściciela, wchodzenie na stanowiska bez pozwolenia prowadzącego oraz lekceważenie jego poleceń.',
      'Każde z tych zachowań może zakończyć się usunięciem ze strzelnicy, a w poważniejszych przypadkach - cofnięciem pozwolenia na broń.',
    ],
    mistake: 'Traktowanie tych zasad jako dobrych praktyk, a nie wiążących wymogów regulaminowych.',
  },

  // ---------------------------------------------------------------- część 6
  'dane-musza-znalezc-sie-w-ksiazce-rejestru-pobytu-na': {
    why: 'Książka rejestru to jedyny dokument prowadzony obowiązkowo na każdej strzelnicy - stąd pytanie o jej zawartość.',
    detail: [
      'W książce rejestru pobytu na strzelnicy wpisuje się imię i nazwisko osoby korzystającej, numer pozwolenia na broń oraz nazwę organu, który je wydał.',
      'Osoba nieposiadająca pozwolenia - na przykład korzystająca z broni klubowej pod nadzorem - podaje zamiast tego adres zamieszkania.',
    ],
    mistake: 'Pomijanie organu wydającego pozwolenie. Sam numer pozwolenia nie wystarcza.',
  },
  'czym-jest-amunicja-bocznego-zaplonu': {
    why: 'Rozróżnienie zapłonu bocznego i centralnego wraca w pytaniach o broń dopuszczoną przez ISSF.',
    detail: [
      'W amunicji bocznego zapłonu masa zapłonowa umieszczona jest w obrzeżu (kryzie) łuski, a iglica uderza w jej brzeg.',
      'Najpopularniejszym przedstawicielem jest kaliber .22 LR (5,6 mm), podstawowa amunicja sportowa i treningowa.',
    ],
    mistake: 'Mylenie zapłonu bocznego z centralnym przy pytaniach o kaliber .22 LR - to zawsze amunicja bocznego zapłonu.',
  },
  'czym-jest-amunicja-centralnego-zaplonu': {
    why: 'Druga połowa pary pojęć - egzamin sprawdza, czy kandydat potrafi je rozdzielić.',
    detail: [
      'W amunicji centralnego zapłonu spłonka umieszczona jest centralnie w denku łuski, a iglica uderza dokładnie w jej środek.',
      'Ten typ stosuje się w broni bojowej, myśliwskiej i sportowej większych kalibrów - pozwala na wyższe ciśnienia i większą energię pocisku.',
    ],
    mistake: 'Uznanie, że amunicja centralnego zapłonu nie jest dopuszczona w sporcie. ISSF dopuszcza ją w wybranych konkurencjach pistoletowych.',
  },
  'amunicje-dopuszcza-issf-do-zawodow': {
    why: 'Pytanie o parametry dopuszczonej amunicji - typowy przykład zagadnienia „liczbowego" z części sportowej.',
    detail: [
      'ISSF dopuszcza w konkurencjach bocznego zapłonu amunicję kalibru 5,6 mm (.22 LR) z pociskami z miękkiego ołowiu lub podobnego miękkiego materiału.',
      'Amunicja musi spełniać wymagania regulaminowe co do przeznaczenia sportowego i energii pocisku.',
    ],
    mistake: 'Podawanie kalibru 6 mm zamiast 5,6 mm - to dwie różne wartości, mylone z granicą kalibru dla pozwolenia sportowego.',
  },
  'ktora-bron-ma-najwiekszy-kaliber-wagomiarowy': {
    why: 'Kalibry wagomiarowe działają odwrotnie niż metryczne - to pułapka logiczna, którą egzamin chętnie wykorzystuje.',
    detail: [
      'W kalibrach wagomiarowych im mniejszy numer, tym większa średnica przewodu lufy. Kaliber 12 jest więc większy niż 16 czy 20.',
      'W konkurencjach ISSF kaliber 12 stanowi górną dopuszczalną granicę dla broni gładkolufowej.',
    ],
    mistake: 'Odruchowe przyjęcie, że większa liczba oznacza większy kaliber. W systemie wagomiarowym zależność jest odwrotna.',
  },
  'bron-pneumatyczna-dopuszcza-issf': {
    why: 'Parametry broni pneumatycznej to zestaw konkretnych liczb - jedno z pytań, których nie da się zgadnąć.',
    detail: [
      'Dla pistoletu pneumatycznego ISSF określa masę do 1500 g, minimalny opór języka spustowego 500 g oraz maksymalne wymiary 420×200×50 mm.',
      'Dla karabinu pneumatycznego dopuszczalna masa sięga 5500 g, a długość linii celowniczej - 850 mm.',
    ],
    mistake: 'Mieszanie parametrów pistoletu i karabinu. To dwa odrębne zestawy wartości.',
  },
  'bron-palna-bocznego-zaplonu-dopuszcza-issf': {
    why: 'Uzupełnia obraz sprzętu dopuszczonego w zawodach - po broni pneumatycznej przychodzi kolej na palną.',
    detail: [
      'W konkurencjach bocznego zapłonu ISSF dopuszcza pistolety i rewolwery kalibru .22 LR oraz karabinki o długości lufy do 762 mm i masie do 8000 g.',
      'Sprzęt ten wykorzystywany jest w konkurencjach pistoletowych i karabinowych, zarówno juniorów, jak i seniorów.',
    ],
    mistake: 'Podawanie masy karabinu pneumatycznego (5500 g) zamiast karabinu bocznego zapłonu (8000 g).',
  },
  'bron-srutowa-moze-byc-uzywana-w-issf': {
    why: 'Konkurencje śrutowe (trap, skeet) są pełnoprawną częścią programu ISSF - pytanie sprawdza znajomość ich wymogów.',
    detail: [
      'ISSF dopuszcza broń gładkolufową kalibru 12 lub mniejszego, z komorą nabojową o długości do 76 mm.',
      'Broń śrutowa wykorzystywana jest w konkurencjach trap i skeet, gdzie celem są rzutki wyrzucane z maszyn.',
    ],
    mistake: 'Uznanie, że sport strzelecki ISSF obejmuje wyłącznie broń kulową.',
  },
  'bron-centralnego-zaplonu-dopuszcza-issf': {
    why: 'Ostatni zestaw parametrów sprzętowych - zamyka blok o broni dopuszczonej w zawodach.',
    detail: [
      'Dla pistoletów centralnego zapłonu ISSF określa kalibry od 7,62 mm (.30") do 9,65 mm (.38"), masę do 1400 g i długość lufy do 153 mm.',
      'Dla karabinów centralnego zapłonu dopuszczalny kaliber sięga 8 mm (.315"), a masa - 8000 g.',
    ],
    mistake: 'Mylenie limitu masy pistoletu (1400 g) z limitem masy pistoletu pneumatycznego (1500 g).',
  },
  'amunicji-nie-wolno-stosowac-w-zawodach-issf': {
    why: 'Zakazy sprzętowe wynikają wprost z bezpieczeństwa zawodów i równości szans - dlatego są sprawdzane osobno.',
    detail: [
      'W zawodach ISSF nie wolno stosować amunicji z pociskami podkalibrowymi lub zawierającymi elementy z tworzyw sztucznych, amunicji z materiałami łatwopalnymi, zapalającymi i wybuchowymi ani pocisków z bardzo twardych metali, takich jak wolfram.',
      'Wykluczona jest też amunicja wytwarzana poza profesjonalnymi fabrykami - z wyjątkiem amunicji elaborowanej na własny użytek przez osoby posiadające odpowiednie uprawnienia.',
    ],
    mistake: 'Utożsamianie zakazu z amunicją elaborowaną. Elaboracja na własny użytek jest dopuszczalna - zakazane są konkretne typy pocisków.',
  },

  // ---------------------------------------------------------------- część 7
  'amunicji-nie-mozna-uzywac-w-zawodach-issf': {
    why: 'Pytanie powtarza zakazy sprzętowe w rozszerzonej formie - egzamin wraca do nich, bo dotyczą bezpieczeństwa zawodów.',
    detail: [
      'Niedozwolona jest amunicja z pociskami podkalibrowymi lub z elementami z tworzyw sztucznych, zawierająca materiały łatwopalne, zapalające albo wybuchowe, a także wykonana z bardzo twardych metali, jak wolfram i jego stopy.',
      'Wyłączona jest również amunicja wytwarzana poza profesjonalnymi fabrykami, poza elaboracją na własny użytek przez osoby z odpowiednimi uprawnieniami. Chodzi o wyrównanie szans i bezpieczeństwo na osi.',
    ],
    mistake: 'Skupianie się wyłącznie na materiałach wybuchowych. Zakaz obejmuje też twarde metale i pociski podkalibrowe.',
  },
  'czym-jest-kaliber-broni': {
    why: 'Definicja kalibru jest punktem wyjścia dla wszystkich pytań o parametry sprzętu w tej części.',
    detail: [
      'Kaliber to podstawowy parametr techniczny broni - średnica wewnętrzna przewodu lufy lub średnica dopasowanego do niej pocisku, podawana w milimetrach albo w calach.',
      'W broni gwintowanej mierzy się go między polami lub między dnami bruzd, co powoduje drobne różnice w oznaczeniach tego samego naboju.',
    ],
    mistake: 'Utożsamianie kalibru z długością naboju. Kaliber opisuje średnicę, nie długość.',
  },
  'co-oznacza-kaliber-wagomiarowy': {
    why: 'Kaliber wagomiarowy to jedyny system, w którym większa liczba oznacza mniejszą lufę - i właśnie dlatego jest pułapką egzaminacyjną.',
    detail: [
      'Kaliber wagomiarowy określa liczbę jednakowych kul ołowianych o średnicy przewodu lufy, które można odlać z jednego funta ołowiu. Im więcej takich kul, tym mniejsza średnica.',
      'Stąd kaliber 12 oznacza lufę szerszą niż kaliber 16 czy 20. System stosuje się do broni gładkolufowej - śrutowej.',
    ],
    mistake: 'Przenoszenie logiki kalibrów metrycznych na wagomiarowe. Tu zależność jest odwrotna.',
  },
  'jest-maksymalna-dlugosc-lufy-pistoletu-dowolnego': {
    why: 'Pytanie sprawdza, czy kandydat wie, że „dowolny" w nazwie konkurencji oznacza realny brak ograniczeń konstrukcyjnych.',
    detail: [
      'W konkurencji pistoletu dowolnego przepisy ISSF nie określają maksymalnej długości lufy. Zawodnik dobiera konstrukcję według własnych preferencji.',
      'Swoboda dotyczy także masy broni i oporu spustu - ograniczenia pojawiają się dopiero w konkurencjach sportowych i pneumatycznych.',
    ],
    mistake: 'Podawanie limitu 153 mm. Ta wartość dotyczy pistoletu sportowego, nie dowolnego.',
  },
  'jest-maksymalna-dlugosc-lufy-pistoletu-sportowego': {
    why: 'Konkretna liczba, sprawdzana podczas kontroli sprzętu przed startem - i typowe pytanie testowe.',
    detail: [
      'Dla pistoletu sportowego ISSF ustala maksymalną długość lufy na 153 mm. Wartość jest weryfikowana przy kontroli sprzętu.',
      'Przekroczenie limitu skutkuje niedopuszczeniem broni do zawodów, niezależnie od pozostałych parametrów.',
    ],
    mistake: 'Mylenie 153 mm z brakiem limitu w pistolecie dowolnym - to najczęściej zestawiana para pytań.',
  },
  'jest-maksymalna-masa-karabinu-pneumatycznego': {
    why: 'Masa karabinu pneumatycznego to jedna z kilku liczb, które trzeba znać dokładnie.',
    detail: [
      'Karabin pneumatyczny wraz z zamontowanymi akcesoriami - celownikami, ciężarkami balansującymi, szynami - nie może przekraczać 5500 g.',
      'Limit obejmuje kompletną broń w konfiguracji startowej, dlatego waży się ją wraz z osprzętem.',
    ],
    mistake: 'Podawanie 8000 g. Ta wartość dotyczy karabinów bocznego i centralnego zapłonu, nie pneumatycznych.',
  },
  'istnieje-ograniczenie-masy-pistoletu-dowolnego': {
    why: 'Kolejne pytanie z serii „dowolny znaczy bez limitu" - egzamin sprawdza konsekwencję tej zasady.',
    detail: [
      'W konkurencji pistoletu dowolnego nie obowiązuje limit masy broni. Zawodnik może dobrać konstrukcję cięższą dla stabilności lub lżejszą dla wygody.',
      'Brak limitu masy idzie w parze z brakiem limitu długości lufy i minimalnego oporu spustu w tej konkurencji.',
    ],
    mistake: 'Przypisywanie pistoletowi dowolnemu limitu 1400 g, właściwego dla pistoletu sportowego.',
  },
  'jest-maksymalna-masa-pistoletu-sportowego': {
    why: 'Wartość powtarzana także w części szóstej - znak, że warto ją zapamiętać na stałe.',
    detail: [
      'Pistolet sportowy nie może przekraczać 1400 g masy, liczonej wraz z chwytem, mechanizmem spustowym i wszystkimi zamontowanymi elementami.',
      'Broń przekraczająca ten limit nie zostanie dopuszczona do startu przy kontroli sprzętu.',
    ],
    mistake: 'Mylenie 1400 g (pistolet sportowy) z 1500 g (pistolet pneumatyczny). Różnica wynosi tylko 100 g.',
  },
  'jest-minimalny-opor-jezyka-spustowego-w-pistolecie-dowolnym': {
    why: 'Opór spustu to parametr bezpieczeństwa - jego brak w konkurencji dowolnej bywa zaskoczeniem.',
    detail: [
      'W pistolecie dowolnym ISSF nie określa minimalnego oporu języka spustowego. Zawodnik ustawia go według własnych preferencji, także bardzo lekko.',
      'Jest to możliwe, bo konkurencja rozgrywana jest w tempie wolnym, z pojedynczymi strzałami oddawanymi na precyzję.',
    ],
    mistake: 'Przypisywanie pistoletowi dowolnemu wartości 500 g lub 1000 g z innych konkurencji.',
  },
  'jest-minimalny-opor-jezyka-spustowego-w-pistolecie': {
    why: 'Wartość 500 g dla broni pneumatycznej pojawia się także w części szóstej - to jedna z najczęściej sprawdzanych liczb.',
    detail: [
      'W pistolecie pneumatycznym minimalny opór języka spustowego wynosi 500 g. Parametr jest weryfikowany przy kontroli sprzętu przed startem.',
      'Wymóg ma charakter czysto bezpieczeństwowy - zbyt lekki spust grozi przypadkowym strzałem.',
    ],
    mistake: 'Zamiana wartości 500 g i 1000 g między pistoletem pneumatycznym a sportowym.',
  },
  'jest-minimalny-opor-jezyka-spustowego-w-pistolecie-sportowym': {
    why: 'Trzecia wartość z serii - razem tworzą klasyczny zestaw pytań „dopasuj liczbę do konkurencji".',
    detail: [
      'Dla pistoletu sportowego minimalny opór języka spustowego wynosi 1000 g, czyli dwukrotnie więcej niż w broni pneumatycznej.',
      'Wyższa wartość standaryzuje wyposażenie zawodników i ogranicza ryzyko niekontrolowanego strzału w konkurencjach szybkich.',
    ],
    mistake: 'Podawanie 500 g. Ta wartość dotyczy pistoletu pneumatycznego.',
  },
  'wymiary-musi-spelniac-pistolet-sportowy': {
    why: 'Kontrola sprzętu odbywa się dosłownie przez włożenie broni do pudełka kontrolnego - stąd konkretne wymiary.',
    detail: [
      'Pistolet sportowy musi zmieścić się w pudełku kontrolnym o wymiarach 300 × 150 × 50 mm.',
      'Sprawdzenie odbywa się przed zawodami; broń niemieszcząca się w pudełku nie zostaje dopuszczona do startu.',
    ],
    mistake: 'Mylenie wymiarów pistoletu sportowego z większym pudełkiem 420 × 200 × 50 mm dla broni pneumatycznej.',
  },
  'wymiary-musi-spelniac-pistolet-pneumatyczny': {
    why: 'Druga połowa pary wymiarowej - egzamin lubi zestawiać oba pudełka kontrolne w jednym pytaniu.',
    detail: [
      'Pistolet pneumatyczny nie może przekraczać wymiarów 420 × 200 × 50 mm.',
      'To jedno z podstawowych kryteriów dopuszczenia broni do konkurencji pneumatycznych, weryfikowane przy kontroli sprzętu.',
    ],
    mistake: 'Podawanie wymiarów 300 × 150 × 50 mm, właściwych dla pistoletu sportowego.',
  },
  'mozna-uzywac-rewolweru-w-konkurencji-pistolet-sportowy-25-m': {
    why: 'Pytanie sprawdza rozumienie zasady, że ISSF określa parametry broni, a nie jej typ konstrukcyjny.',
    detail: [
      'Rewolwer może być używany w konkurencji „Pistolet sportowy 25 m", o ile spełnia wymagania regulaminowe: kaliber, masę, długość lufy i minimalny opór spustu.',
      'Decyduje zgodność parametrów z regulaminem, a nie sama konstrukcja mechanizmu.',
    ],
    mistake: 'Odpowiedź „nie, dopuszczone są tylko pistolety samopowtarzalne".',
  },
  'naboi-laduje-sie-do-pistoletu-dowolnego': {
    why: 'Pytanie o przebieg konkurencji precyzyjnej - jeden nabój na strzał to cecha charakterystyczna tej dyscypliny.',
    detail: [
      'W konkurencji pistoletu dowolnego ładuje się jeden nabój na raz. Każdy strzał oddawany jest osobno, bez presji czasu typowej dla konkurencji szybkich.',
      'Taki przebieg wymusza rytm pracy oparty na precyzji, a nie na tempie.',
    ],
    mistake: 'Przenoszenie zasad konkurencji szybkostrzelnych, gdzie strzela się seriami, na pistolet dowolny.',
  },
  'zasady-dotyczace-ubioru-zawodnikow': {
    why: 'Przepisy o ubiorze mają wyrównywać szanse - to częsty temat pytań o „sprzęt wspomagający".',
    detail: [
      'Odzież zawodnika nie może wspomagać utrzymania pozycji ani stabilizować sylwetki. Zakazane są buty zakrywające kostki, kamizelki usztywniające oraz pasy stabilizujące.',
      'Kontrola stroju odbywa się razem z kontrolą sprzętu, a naruszenie skutkuje niedopuszczeniem do startu.',
    ],
    mistake: 'Uznanie, że przepisy dotyczą wyłącznie broni. Strój podlega kontroli na równi ze sprzętem.',
  },
  'czym-jest-konkurencja-karabin-dowolny-60-strzalow-lezac': {
    why: 'Konkretna konkurencja z programu ISSF - pytanie sprawdza znajomość dystansu, liczby strzałów i postawy naraz.',
    detail: [
      'To klasyczna konkurencja ISSF: 60 strzałów z karabinu na dystansie 50 metrów, oddawanych w postawie leżącej. Każdy strzał punktowany jest osobno.',
      'Postawa leżąca zapewnia największą stabilność, dlatego wyniki w tej konkurencji należą do najwyższych w strzelectwie karabinowym.',
    ],
    mistake: 'Mylenie dystansu 50 m z 300 m, zarezerwowanym dla konkurencji międzynarodowych.',
  },

  // ---------------------------------------------------------------- część 8
  'konkurencje-naleza-do-strzelby-gladkolufowej': {
    why: 'Otwiera blok o konkurencjach - warto znać wszystkie cztery nazwy, bo pytania podają je w różnych zestawieniach.',
    detail: [
      'Do konkurencji ze strzelbą gładkolufową należą skeet, trap, double trap oraz automatic trap. Wszystkie polegają na strzelaniu do rzutków - ceramicznych dysków wyrzucanych z maszyn.',
      'Różnią się sposobem wyrzucania celów, ich liczbą i przewidywalnością toru lotu.',
    ],
    mistake: 'Pomijanie double trap i automatic trap przy wyliczaniu konkurencji śrutowych.',
  },
  'mozna-zaladowac-magazynek-podczas-zawodow-na-25-m': {
    why: 'Łączy zasady bezpieczeństwa z przebiegiem zawodów - ładowanie przed komendą to poważne naruszenie.',
    detail: [
      'Magazynek wolno załadować dopiero po komendzie „ŁADUJ" wydanej przez prowadzącego strzelanie.',
      'Załadowanie broni wcześniej jest naruszeniem regulaminu i może skutkować ostrzeżeniem, odjęciem punktów, a w skrajnych przypadkach dyskwalifikacją.',
    ],
    mistake: 'Przygotowywanie magazynka „na zapas" jeszcze przed komendą, żeby zyskać czas.',
  },
  'odleglosci-w-konkurencjach-pistoletowych-issf': {
    why: 'Dystanse to najłatwiejsze punkty w tej części - wystarczy zapamiętać je parami z rodzajem broni.',
    detail: [
      'W konkurencjach pistoletowych ISSF obowiązują trzy dystanse: 10 m, 25 m i 50 m.',
      'Przypisanie jest stałe: pistolet pneumatyczny - 10 m, pistolet sportowy i szybkostrzelny - 25 m, pistolet dowolny - 50 m.',
    ],
    mistake: 'Dodawanie dystansu 300 m, który dotyczy wyłącznie konkurencji karabinowych.',
  },
  'odleglosci-w-konkurencjach-karabinowych-issf': {
    why: 'Bliźniacze pytanie do poprzedniego, ale z inną listą - i właśnie na tej różnicy opiera się pułapka.',
    detail: [
      'W konkurencjach karabinowych obowiązują dystanse 10 m, 50 m i 300 m.',
      'Zawody na 300 m rozgrywane są głównie na poziomie międzynarodowym i wymagają specjalistycznych obiektów.',
    ],
    mistake: 'Wpisywanie 25 m do konkurencji karabinowych. Ten dystans należy do pistoletowych.',
  },
  'odleglosci-obowiazuja-w-konkurencjach-issf': {
    why: 'Pytanie zbiorcze - sprawdza, czy kandydat potrafi połączyć obie wcześniejsze listy.',
    detail: [
      'Pełen zestaw oficjalnych dystansów ISSF to 10, 25, 50 i 300 metrów.',
      'Konkretny dystans zależy od konkurencji, rodzaju broni oraz kategorii wiekowej zawodnika.',
    ],
    mistake: 'Podawanie tylko trzech dystansów. Pełna lista obejmuje cztery wartości.',
  },
  'na-jaka-odleglosc-strzela-sie-w-konkurencji-pistolet': {
    why: 'Konkretna konkurencja i konkretny dystans - pytanie o „pistolet sportowy 30+30" wraca w kilku wariantach.',
    detail: [
      'Konkurencja 30+30 rozgrywana jest na dystansie 25 metrów. Zawodnik oddaje 60 strzałów: 30 w tempie wolnym i 30 w tempie szybkim.',
      'Podział na dwie części sprawdza zarówno precyzję, jak i umiejętność pracy pod presją czasu.',
    ],
    mistake: 'Mylenie dystansu 25 m z 50 m, właściwym dla pistoletu dowolnego.',
  },
  'wyglada-konkurencja-pistolet-szybkostrzelny': {
    why: 'Konkurencja charakterystyczna dla ISSF - pytanie sprawdza liczbę tarcz i dystans.',
    detail: [
      'W pistolecie szybkostrzelnym strzela się do pięciu tarcz z odległości 25 metrów, w ściśle określonych limitach czasowych.',
      'Liczy się rytm i czas reakcji - to jedna z najbardziej dynamicznych konkurencji programu.',
    ],
    mistake: 'Podawanie innej liczby tarcz niż pięć.',
  },
  'konkurencje-odbywaja-sie-na-10-metrow': {
    why: 'Dystans 10 m to punkt wejścia do strzelectwa sportowego - stąd częste pytania o niego.',
    detail: [
      'Na 10 metrów rozgrywane są konkurencje z karabinem i pistoletem pneumatycznym, w postawie stojącej.',
      'To najpopularniejszy dystans wśród juniorów i osób rozpoczynających przygodę ze strzelectwem sportowym.',
    ],
    mistake: 'Zaliczanie do 10 m konkurencji z bronią palną bocznego zapłonu.',
  },
  'konkurencje-odbywaja-sie-na-25-metrow': {
    why: 'Dystans typowo pistoletowy, o który pyta się w parze z 10 m i 50 m.',
    detail: [
      'Na 25 metrów rozgrywane są konkurencje z pistoletem sportowym, pistoletem centralnego zapłonu oraz pistoletem szybkostrzelnym.',
      'Wszystkie wymagają połączenia precyzji z pracą w narzuconym tempie.',
    ],
    mistake: 'Umieszczanie na tym dystansie pistoletu dowolnego, który strzela z 50 m.',
  },
  'konkurencje-odbywaja-sie-na-50-metrow': {
    why: 'Najdłuższy z powszechnie spotykanych dystansów krajowych - zamyka zestaw pytań o odległości.',
    detail: [
      'Na 50 metrów rozgrywane są konkurencje z karabinem dowolnym i sportowym oraz konkurencje z tarczą ruchomą.',
      'Na tym dystansie liczy się przygotowanie sprzętowe i umiejętność czytania warunków atmosferycznych.',
    ],
    mistake: 'Pomijanie konkurencji z tarczą ruchomą przy wyliczaniu konkurencji na 50 m.',
  },
  'postawy-w-konkurencjach-karabinowych': {
    why: 'Trzy postawy to fundament konkurencji karabinowych i temat pytań również na egzaminie praktycznym.',
    detail: [
      'W konkurencjach karabinowych występują trzy postawy: leżąca (najbardziej stabilna), stojąca (najtrudniejsza) oraz klęcząca (pośrednia).',
      'W trójboju zawodnik strzela we wszystkich trzech postawach, co sprawdza pełen zakres umiejętności.',
    ],
    mistake: 'Wymienianie tylko dwóch postaw - leżącej i stojącej - z pominięciem klęczącej.',
  },
  'jakie-sa-dyscypliny-strzelectwa-sportowego': {
    why: 'Podstawowy podział, od którego zaczyna się cała systematyka konkurencji ISSF.',
    detail: [
      'ISSF wyróżnia trzy podstawowe grupy dyscyplin: karabin, pistolet i strzelbę.',
      'Każda z nich obejmuje wiele konkurencji różniących się dystansem, postawą i rodzajem dopuszczonego sprzętu.',
    ],
    mistake: 'Dodawanie broni pneumatycznej jako czwartej dyscypliny. To rodzaj broni w ramach grup karabinowej i pistoletowej.',
  },
  'typy-pistoletow-dopuszcza-issf': {
    why: 'Pełna lista typów pistoletów porządkuje wcześniejsze pytania o parametry i dystanse.',
    detail: [
      'ISSF dopuszcza pistolety: dowolny, sportowy, szybkostrzelny, centralnego zapłonu oraz pneumatyczny.',
      'Każdy typ ma odrębne wymagania co do masy, długości lufy, oporu spustu i wymiarów kontrolnych.',
    ],
    mistake: 'Pomijanie pistoletu centralnego zapłonu przy wyliczaniu typów dopuszczonych w zawodach.',
  },
  'na-czym-polega-konkurencja-skeet': {
    why: 'Skeet i trap to para konkurencji śrutowych, których różnicę egzamin sprawdza najczęściej.',
    detail: [
      'W skeecie rzutki wyrzucane są z dwóch wież - wysokiej i niskiej - po stałych, znanych zawodnikowi torach, pojedynczo lub w parach.',
      'Zawodnik zna kierunek lotu, ale musi błyskawicznie ocenić moment i oddać strzał w krótkim oknie czasowym.',
    ],
    mistake: 'Mylenie skeetu z trapem. W skeecie tory są stałe i znane, w trapie - losowe.',
  },
  'na-czym-polega-konkurencja-trap': {
    why: 'Druga połowa pary - tu decyduje losowość toru lotu rzutka.',
    detail: [
      'W trapie rzutki wyrzucane są z maszyn ukrytych w bunkrze przed stanowiskami, w sposób losowy: pod różnymi kątami i na różnych wysokościach.',
      'Zawodnik nie zna kierunku lotu, dlatego liczy się refleks i umiejętność szybkiego złożenia się do strzału.',
    ],
    mistake: 'Opisywanie trapu jako strzelania do rzutków z dwóch wież - to charakterystyka skeetu.',
  },
  'kary-stosuje-sie-za-naruszenie-regulaminu-issf': {
    why: 'Sankcje sportowe różnią się od karnych - pytanie sprawdza, czy kandydat je rozdziela.',
    detail: [
      'Regulamin ISSF przewiduje stopniowaną reakcję: ostrzeżenie ustne, odjęcie punktów, a w najpoważniejszych przypadkach dyskwalifikację zawodnika.',
      'Są to sankcje sportowe, niezależne od ewentualnej odpowiedzialności wynikającej z przepisów o broni.',
    ],
    mistake: 'Mylenie kar regulaminowych z karami z ustawy o broni i amunicji - to dwa odrębne porządki.',
  },
  'grozi-za-noszenie-broni-po-spozyciu-alkoholu-lub-srodkow': {
    why: 'Jedno z najpoważniejszych naruszeń, powiązane z bezwzględnym zakazem obowiązującym na strzelnicy.',
    detail: [
      'Noszenie broni po spożyciu alkoholu lub środków psychoaktywnych zagrożone jest karą aresztu albo grzywny.',
      'Niezależnie od sankcji karnej organ Policji może cofnąć pozwolenie na broń - i w praktyce właśnie tak się dzieje.',
    ],
    mistake: 'Zakładanie, że liczy się dopiero stan nietrzeźwości. Przepis obejmuje już stan po spożyciu.',
  },
  'grozi-za-porzucenie-broni-lub-amunicji': {
    why: 'Pytanie o konkretny wymiar kary - takie wartości warto zapamiętać dosłownie.',
    detail: [
      'Porzucenie broni lub amunicji zagrożone jest karą pozbawienia wolności do lat 2.',
      'Przepis wynika z obowiązku stałego nadzoru nad bronią - nawet chwilowe pozostawienie jej bez kontroli może zostać tak zakwalifikowane.',
    ],
    mistake: 'Traktowanie porzucenia jako wykroczenia. To przestępstwo z Kodeksu karnego.',
  },
  'grozi-za-brak-rejestracji-lub-zlozenia-broni': {
    why: 'Domyka wątek terminów rejestracyjnych z części pierwszej i drugiej, pokazując sankcję.',
    detail: [
      'Brak rejestracji broni w wymaganym terminie lub niezłożenie jej do depozytu zagrożone jest karą grzywny albo aresztu.',
      'Przypomnijmy termin: rejestracja następuje w ciągu 5 dni od nabycia, a złożenie broni do depozytu po utracie uprawnień - w ciągu 30 dni.',
    ],
    mistake: 'Zakładanie, że brak rejestracji to jedynie kwestia formalna bez sankcji.',
  },
  'grozi-za-posiadanie-lub-zbycie-broni-pneumatycznej-bez': {
    why: 'Broń pneumatyczna bywa lekceważona, a jej brak rejestracji również jest karalny.',
    detail: [
      'Posiadanie lub zbycie broni pneumatycznej bez wymaganej rejestracji zagrożone jest karą aresztu albo grzywny.',
      'Dotyczy to każdego, kto nabył broń pneumatyczną o energii powyżej 17 J - także osób nieposiadających pozwolenia na broń palną.',
    ],
    mistake: 'Przekonanie, że broń pneumatyczna jest całkowicie poza reżimem ustawy. Powyżej 17 J wymaga karty rejestracyjnej.',
  },

  // ---------------------------------------------------------------- część 9
  'grozi-za-brak-zgloszenia-zbycia-lub-utraty-broni-amunicji': {
    why: 'Obowiązki informacyjne wracają tu od strony sankcji - to podsumowanie wątku z części trzeciej.',
    detail: [
      'Każde zbycie, utratę lub kradzież broni należy niezwłocznie zgłosić Policji. Zaniechanie jest wykroczeniem zagrożonym karą grzywny albo aresztu.',
      'Przypomnijmy termin: utratę broni zgłasza się najpóźniej w ciągu 24 godzin od jej stwierdzenia.',
    ],
    mistake: 'Odkładanie zgłoszenia do czasu „wyjaśnienia sprawy". Obowiązek jest natychmiastowy.',
  },
  'grozi-za-brak-zgloszenia-zmiany-miejsca-stalego-pobytu': {
    why: 'Drobna formalność z realną sankcją - dlatego pojawia się w części o odpowiedzialności.',
    detail: [
      'Zmianę miejsca stałego pobytu trzeba zgłosić w ciągu 14 dni organowi właściwemu dla nowego adresu. Niedopełnienie obowiązku jest wykroczeniem.',
      'W skrajnych przypadkach może stanowić przesłankę do cofnięcia pozwolenia, bo uniemożliwia kontrolę warunków przechowywania broni.',
    ],
    mistake: 'Mylenie 14 dni z 5 dniami na rejestrację broni.',
  },
  'grozi-za-nieumyslna-utrate-broni-lub-amunicji': {
    why: 'Pytanie pokazuje, że odpowiedzialność nie wymaga złej woli - wystarczy niedbalstwo.',
    detail: [
      'Nieumyślna utrata broni lub amunicji - na przykład zgubienie w transporcie - zagrożona jest karą grzywny, ograniczenia wolności albo pozbawienia wolności do roku.',
      'Odpowiedzialność wynika z samego faktu utraty nadzoru nad bronią, niezależnie od intencji posiadacza.',
    ],
    mistake: 'Założenie, że brak winy umyślnej wyłącza odpowiedzialność.',
  },
  'czym-jest-stan-wyzszej-koniecznosci': {
    why: 'Instytucja z Kodeksu karnego, którą egzamin zestawia z obroną konieczną - kluczowe jest rozróżnienie obu.',
    detail: [
      'Stan wyższej konieczności to działanie w celu uchylenia bezpośredniego niebezpieczeństwa grożącego dobru chronionemu prawem, przy poświęceniu innego dobra o wartości niższej niż ratowane.',
      'Niebezpieczeństwo nie musi pochodzić od człowieka - może to być pożar, powódź czy awaria. Tym różni się od obrony koniecznej.',
    ],
    mistake: 'Mylenie ze stanem obrony koniecznej. Tu kluczowe jest porównanie wartości dóbr, a nie odpieranie zamachu.',
  },
  'czym-jest-obrona-konieczna': {
    why: 'Najważniejsze pojęcie tej części - ma bezpośrednie znaczenie dla każdego posiadacza broni.',
    detail: [
      'Obrona konieczna to odparcie bezpośredniego, bezprawnego zamachu na dobro chronione prawem - życie, zdrowie, mienie czy nietykalność.',
      'Zamach musi być bezpośredni (trwający lub nieuchronny) i bezprawny, a sposób obrony współmierny do niebezpieczeństwa. Prawo dopuszcza użycie broni, jeśli te warunki są spełnione.',
    ],
    mistake: 'Uznanie, że obrona konieczna obejmuje odwet po zakończonym zamachu. Zamach musi trwać lub być nieuchronny.',
  },
  'sad-moze-odstapic-od-kary-za-przekroczenie-obrony-koniecznej': {
    why: 'Uzupełnia pojęcie obrony koniecznej o skutki przekroczenia jej granic.',
    detail: [
      'Sąd może odstąpić od wymierzenia kary, jeżeli przekroczenie granic obrony koniecznej nastąpiło pod wpływem strachu lub wzburzenia usprawiedliwionych okolicznościami zamachu.',
      'Klasycznym przykładem jest nocny napad w mieszkaniu, gdzie reakcja broniącego się jest naturalnie nieproporcjonalna do zagrożenia.',
    ],
    mistake: 'Przekonanie, że przekroczenie granic obrony koniecznej zawsze oznacza karę.',
  },
  'sad-moze-zlagodzic-kare-za-przekroczenie-stanu-wyzszej': {
    why: 'Analogiczna konstrukcja jak przy obronie koniecznej - egzamin sprawdza, czy kandydat widzi tę symetrię.',
    detail: [
      'Sąd może zastosować nadzwyczajne złagodzenie kary, a nawet odstąpić od jej wymierzenia, gdy sprawca przekroczył granice stanu wyższej konieczności.',
      'Znaczenie mają okoliczności działania - zwłaszcza gdy chodziło o ratowanie życia lub zdrowia i sprawca działał w dobrej wierze.',
    ],
    mistake: 'Traktowanie przekroczenia granic jako okoliczności zawsze wyłączającej odpowiedzialność.',
  },
  'grozi-za-noszenie-broni-z-naruszeniem-ograniczenia-lub': {
    why: 'Domyka wątek ograniczeń noszenia broni, obecny już w częściach drugiej i trzeciej.',
    detail: [
      'Noszenie broni wbrew nałożonemu ograniczeniu lub zakazowi zagrożone jest karą grzywny albo aresztu.',
      'Niezależnie od sankcji karnej naruszenie stanowi podstawę do cofnięcia pozwolenia na broń.',
    ],
    mistake: 'Zakładanie, że skoro pozwolenie nadal obowiązuje, ograniczenie ma charakter jedynie porządkowy.',
  },
  'grozi-za-uzycie-broni-poza-strzelnica-w-celach': {
    why: 'Pytanie pilnuje zasady zgodności użycia broni z celem pozwolenia - wątku obecnego od części pierwszej.',
    detail: [
      'Broń do celów sportowych może być używana wyłącznie na strzelnicach. Użycie jej poza strzelnicą, nawet przez osobę z ważnym pozwoleniem, jest naruszeniem przepisów.',
      'Konsekwencją może być odpowiedzialność karna oraz cofnięcie pozwolenia na broń.',
    ],
    mistake: 'Uznanie, że posiadanie pozwolenia sportowego uprawnia do strzelania w dowolnym bezpiecznym miejscu.',
  },
  'grozi-za-przywoz-broni-spoza-ue-bez-dokumentu-konsula': {
    why: 'Uzupełnia pytanie o dokumenty przywozowe z części trzeciej, tym razem od strony sankcji.',
    detail: [
      'Przywóz broni spoza Unii Europejskiej bez zaświadczenia wydanego przez konsula RP stanowi naruszenie przepisów celnych i ustawy o broni.',
      'Skutkiem może być zatrzymanie broni, odpowiedzialność karna oraz cofnięcie pozwolenia.',
    ],
    mistake: 'Poleganie na Europejskiej karcie broni palnej przy przywozie spoza Unii - ona dotyczy przemieszczania wewnątrz UE.',
  },
  'grozi-za-produkcje-lub-handel-bronia-bez-zezwolenia': {
    why: 'Najsurowiej karane naruszenie w tej części - warto znać widełki kary.',
    detail: [
      'Nielegalne wyrabianie, przetwarzanie lub handel bronią palną i amunicją zagrożone jest karą pozbawienia wolności od roku do 10 lat.',
      'Przepis obejmuje zarówno działalność zorganizowaną, jak i pojedyncze przypadki wytwarzania broni bez wymaganej koncesji.',
    ],
    mistake: 'Mylenie tej sankcji z karą za nielegalne posiadanie broni (od 6 miesięcy do 8 lat).',
  },
  'grozi-za-nielegalne-posiadanie-broni-palnej-lub-amunicji': {
    why: 'Zamyka cały zestaw pytań - to podstawowy przepis karny dotyczący broni.',
    detail: [
      'Posiadanie broni palnej lub amunicji bez wymaganego pozwolenia jest przestępstwem zagrożonym karą pozbawienia wolności od 6 miesięcy do 8 lat.',
      'Przypomnijmy, że jak broń traktowane są także jej istotne części - ich posiadanie bez pozwolenia podlega tej samej ocenie prawnej.',
    ],
    mistake: 'Zakładanie, że posiadanie samej amunicji bez broni nie podlega karze. Podlega tak samo.',
  },
};
